import Horoscopes from './Horoscopes';

export default Horoscopes;